import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {concat, Observable, of, Subject, zip} from 'rxjs';
import { GroupsService } from './groups.service';
import { User } from '../components/users/user';
import { LoaderService } from './loader.service';


@Injectable({
  providedIn: 'root'
})
export class UserService
 {
    constructor(private groupsService: GroupsService,
                private loader: LoaderService){
        
    }

    private subject = new Subject<any>();

    updateUser(): Observable<any> {
        return this.subject.asObservable();
    }

    private user: User;
    

    storeUser() {
        let obj = {... this}
        let seen = [];
        localStorage.setItem('userS' , JSON.stringify(this.user));
        localStorage.setItem('report.generation', this.getSystemProperty("report.generation"));
        
    }

    setUser (payload: any) : void{

        this.user = new User();
        this.user.groups = {};
        this.user.username = payload.user_name;
        this.user.authorities = payload.authorities;
        this.user.laboratoryId = payload.laboratory_id;
        this.user.groups['report'] = payload.reportGroups.sort((a,b) => a.description > b.description ? 1 : -1);
        this.user.groups['order-entry'] = payload.orderEntryGroups.sort((a,b) => a.description > b.description ? 1 : -1);
        this.user.groups['phlebotomy'] = payload.phlebotomyGroups.sort((a,b) => a.description > b.description ? 1 : -1);
        this.user.groups['configuration'] = payload.configurationGroups.sort((a,b) => a.description > b.description ? 1 : -1);
        this.user.systemProperties = payload.systemProperties;

        this.storeUser()

    }

    getUser () :User {
        if (this.user != undefined) {
            return this.user;
          } else if (localStorage.getItem('userS') != null) {
              this.user = JSON.parse(localStorage.getItem('userS')) as User;
              return this.user;
          }
          return undefined;
    }

    setActiveGroup (groupType, groupId) : void {

        this.loader.show();
        this.loader.setForced(true)

        if( this.user == undefined){
            this.user = this.getUser();
            this.loader.hide(true);
            this.loader.setForced(false)
        } else {
            zip(this.groupsService.getProperties(groupType, groupId),
                this.groupsService.getWards(groupType, groupId))
                .subscribe(
                    (data) => {
                        this.user[groupType] = data[0].id;
                        this.user.groups[groupType][this.getGroupIndex(groupType, groupId)] = data[0];
                        this.user.groups[groupType][this.getGroupIndex(groupType, groupId)].wards = data[1];
                        this.subject.next(this.user);
                        this.storeUser()

                        this.loader.hide(true);
                        this.loader.setForced(false)
                    }
                    
                )
        }

    }

    getActiveGroup(groupType): any{

        if(!this.user) this.getUser()

        if(this.user[groupType]){
            return this.user.groups[groupType][this.getGroupIndex(groupType, this.user[groupType])];
        }else {
            return null;
        }
    }

    getWards(groupType, groupId){
        return this.user.groups[groupType].find( item => item.id == groupId).wards;
    }

    getGroupIndex(groupType, groupId){
        return this.user.groups[groupType].findIndex( el => el.id == groupId);
    }


    getSystemProperty(prop){
        return this.user.systemProperties.filter(elem => elem.parameterId ==prop)[0].parameterValue
    }

    hasRole(role){
        return this.user.authorities.indexOf(role) > -1;
    }
 

}